/**
 * Auth Utility Functions
 * Handles caching, data conversion, and other utility functions
 */
/**
 * Convert Stytch Member to UserProfile
 */
export function convertMemberToUserProfile(member, organizationId) {
    const extendedMember = member;
    // Safely extract metadata with proper typing
    const trustedMetadata = member.trusted_metadata;
    const role = trustedMetadata?.role || (extendedMember.is_admin ? 'admin' : 'member');
    const permissions = trustedMetadata?.permissions || [];
    const roles = trustedMetadata?.roles || [extendedMember.is_admin ? 'admin' : 'member'];
    return {
        id: member.member_id,
        email: member.email_address,
        name: member.name || '',
        role,
        workspaceId: typeof trustedMetadata?.workspace_id === 'string' && trustedMetadata.workspace_id.trim()
            ? trustedMetadata.workspace_id
            : undefined,
        createdAt: member.created_at,
        updatedAt: member.updated_at,
        stytchMemberId: member.member_id,
        stytchOrganizationId: organizationId,
        permissions,
        roles,
    };
}
/**
 * Create cache utility functions
 */
export function createCacheUtils(cache) {
    console.log('createCacheUtils called with cache:', cache);
    console.log('cache type:', typeof cache);
    console.log('cache has set method:', cache && typeof cache.set === 'function');
    const cacheUserProfile = (user) => {
        if (!cache || !user.id)
            return;
        cache.set(`auth:user:${user.id}`, user, {
            ttl: 30 * 60 * 1000, // 30 minutes
            workspaceId: user.workspace_id,
            userId: user.id,
            tags: ['auth', 'user-profile'],
        });
    };
    const cacheWorkspace = (ws) => {
        if (!cache || !ws.id)
            return;
        cache.set(`auth:workspace:${ws.id}`, ws, {
            ttl: 60 * 60 * 1000, // 1 hour
            workspaceId: ws.id,
            tags: ['auth', 'workspace'],
        });
    };
    const cachePermissions = (userId, permissions, roles) => {
        if (!cache)
            return;
        cache.set(`auth:permissions:${userId}`, { permissions, roles }, {
            ttl: 15 * 60 * 1000, // 15 minutes
            userId,
            tags: ['auth', 'permissions'],
        });
    };
    const getCachedPermissions = (userId) => {
        if (!cache)
            return null;
        return cache.get(`auth:permissions:${userId}`, undefined, userId);
    };
    const clearAuthCache = () => {
        if (!cache)
            return;
        cache.invalidate('auth:*');
    };
    return {
        cacheUserProfile,
        cacheWorkspace,
        cachePermissions,
        getCachedPermissions,
        clearAuthCache,
    };
}
